import { render, staticRenderFns } from "./StatsTable.vue?vue&type=template&id=3f4f6d82&"
import script from "./StatsTable.vue?vue&type=script&lang=js&"
export * from "./StatsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports